import React, { useCallback, useEffect } from 'react'
import { Accordion, Card, Col, Container, Image, Row } from 'react-bootstrap'
import './blogStyles.css'
import { useDispatch, useSelector } from 'react-redux'
import { fetching_All_Blogs, fetching_Blog_By_ID, fetching_blog_categories } from '../../services/Services'
import { useParams } from 'react-router'
import Loading from '../loading'

const Blog = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const queryParams = new URLSearchParams(location.search);
    const { blogToShow, blogs, blogCategories, loading } = useSelector(state => state.blog);
    // let id = queryParams.get('id');

    const { title, content, image, date } = blogToShow || {};

    const onFetchBlog = useCallback(async () => {
        await fetching_Blog_By_ID(dispatch, id);
    }, [id]);

    useEffect(() => {
        onFetchBlog();
        fetching_All_Blogs(dispatch);
        fetching_blog_categories(dispatch);
        window.scrollTo(0, 0);
    }, [])

    const posts = useCallback((item, index) => {
        return (
            <>
                <hr />
                <a href="javascript:void(0);" className='p-0 m-0' onClick={() => fetching_Blog_By_ID(dispatch, item?.post_name)} >
                    <Row className='p-0'>
                        <Col lg='3' md='3' sm='3' xs='3' className='contain-center'>
                            <Image src={item.image || 'https://via.placeholder.com/60x60'} fluid />
                        </Col>
                        <Col lg='9' md='9' sm='9' xs='9' className='text-left-vertical-center' >
                            <h6>{item?.title}</h6>
                        </Col>
                    </Row>
                </a>
            </>
        )
    }, [])

    const categories = useCallback((item, index) => {
        return (
            <Accordion className='border mb-1' >
                <Accordion.Item eventKey={index} >
                    <Accordion.Header className='accordionHeader'>{item?.category_name}</Accordion.Header>
                    <Accordion.Body>
                        {
                            item?.blogs?.map(posts)
                        }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        )
    }, [])

    return !loading ? (
        <Container className='pt-5 mt-5 pb-5'>
            <Row>
                <Col lg='8'>
                    <h2 className='mb-4' >{title}</h2>
                    <p>
                        <Image src={image || 'https://via.placeholder.com/800x400'} fluid />
                    </p>
                    <h5 className='mb-4' >{date}</h5>
                    <p dangerouslySetInnerHTML={{ __html: content }} />
                </Col>
                <Col lg='4'>
                    <Card id='card'>
                        <Card.Body>
                            <h4 className='mb-4' >Recent Posts</h4>
                            <Card.Text>
                                {
                                    blogs?.map(posts)
                                }
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card id='card'>
                        <Card.Body>
                            <h4 className='mb-4' >Categories</h4>

                            {
                                blogCategories.map(categories)
                            }
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    ) : <Loading />
}

export default Blog